import { Listing, VariablesData } from './types'
import { TriggerListData } from '../sub-components/TriggerList'

export const replaceVariablesWithValues = (text: string, data: VariablesData): string[] => {
  const variableKeys = Object.values(data).map(item => {
    return { key: item.txt_id, name: item.name }
  })

  variableKeys.forEach(item => {
    const regex = new RegExp(`\\[\\s*${item.name}\\s*\\]`, 'g')
    text = text.replace(regex, data[item.key].example)
  })

  return text.split('\n')
}

export const variablesDropdown = (data: VariablesData) => {
  const transformedArr = []

  for (const key in data) {
    const item = data[key]
    transformedArr.push({
      label: item.name,
      value: item.variable
    })
  }

  return transformedArr
}

export const snakeToSentence = (snakeStr: string) => {
  let words = snakeStr.split('_')
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1)
  let sentence = words.join(' ')

  return sentence
}

export const GroupAutoReply = {
  'Message Received': [
    'first_tenant_message_received',
    'every_tenant_message_received_5_minutes',
    'first_tenant_message_received_for_the_day'
  ],
  'Tenant Interaction': [
    'application_received',
    'invited_to_apply',
    'invited_to_apply_no_response_3_days'
  ],
  'Listing Management': [
    'new_contract_fully_signed',
    'rent_payment_reminder_3_days_prior',
    'unit_has_been_rented',
    'tenant_application_copied'
  ]
}

type PriceFrequency = 'weekly' | 'daily' | 'monthly' | 'yearly'

const priceFrequency: { [key in PriceFrequency]: string } = {
  weekly: 'week',
  daily: 'day',
  monthly: 'month',
  yearly: 'year'
}

export const getFilteredData = (data: TriggerListData[], title: string): TriggerListData[] => {
  return data?.filter(item =>
    GroupAutoReply[title as keyof typeof GroupAutoReply]?.includes(item.txt_id)
  )
}

export const transformListingData = (listing: Listing) => {
  const description = `${listing?.city}, ${listing?.state} · ${
    listing?.price
      ? `$${parseFloat(listing?.price)}/${
          priceFrequency[listing.price_frequency as PriceFrequency]
        }`
      : ''
  }`

  const badges = []
  if (listing?.is_hidden === '1') {
    badges.push({
      label: 'Hidden',
      tone: 'neutral' as const,
      weight: 'strong' as const
    })
  }

  if (listing?.state_machine === 'draft') {
    badges.push({
      label: 'Draft',
      tone: 'info' as const,
      weight: 'strong' as const
    })
  } else if (listing?.state_machine === 'pending') {
    badges.push({
      label: 'Pending',
      tone: 'caution' as const,
      weight: 'strong' as const
    })
  }

  return {
    id: listing?.listing_id,
    label: `${listing?.unit_number ? `${listing.unit_number} - ` : ''}${listing?.street_number} ${
      listing?.street_name
    } `,
    description: description,
    badges: badges
  }
}

export const findBracketedWords = (
  input: string,
  lookUpArray: string[]
): { start: number; end: number }[] => {
  const matches = [...input.matchAll(/\[([^\][]+)\]/g)]
  return matches
    .filter(match => lookUpArray.includes(match[0]))
    .map(match => ({
      start: match.index!,
      end: match.index! + match[0].length
    }))
}
